import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function Intro({ onDone, onFinish }) {
  const [visible, setVisible] = useState(true);
  const done = onFinish || onDone;

  useEffect(() => {
    const reduced =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const dur = reduced ? 1400 : 2600;
    const t = setTimeout(finish, dur);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finish = () => {
    setVisible(false);
    setTimeout(() => done?.(), 500);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="intro-sequence"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] bg-black flex items-center justify-center overflow-hidden"
        >
          <motion.img
            src="/assets/logos/logo_gold.png"
            alt="Philadelphia Freeway 23rd Anniversary"
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: "easeOut" }}
            className="w-40 sm:w-48 md:w-56 h-auto object-contain intro-rock drop-shadow-[0_0_35px_rgba(212,175,55,0.4)]"
          />

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.55 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="absolute bottom-24 left-1/2 -translate-x-1/2 font-mono text-[10px] tracking-[0.5em] uppercase text-white/60"
          >
            FTA X PLANES · 2003 — 2026
          </motion.div>

          <button
            data-testid="intro-skip-btn"
            onClick={finish}
            className="absolute bottom-6 right-6 font-mono text-[10px] tracking-[0.3em] uppercase text-white/50 hover:text-[#D4AF37] transition-colors border border-white/15 hover:border-[#D4AF37] px-4 py-2"
          >
            Skip Intro →
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
